import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppTypesApiResponse } from '../../model/app';
import { CommonService } from '../../services/common.service';
import { Navigation, Router } from '@angular/router';
import { User } from 'src/app/model/user';
import { OnBoardingLibraryDto } from './models/onboardingLibrary.dto.interface';
import { on } from 'events';
import { SECTIONS_PAGE } from 'src/app/Utils/globals';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService extends CommonService {
  getCountries() {
    return this.httpClient.get(
      environment.urls.apiBaseUrl + 'cross/getcountries',
      { withCredentials: true },
    );
  }

  createAsset(
    params: OnBoardingLibraryDto | any,
    isApp = true,
  ): Observable<any> {
    const url = isApp
      ? `${environment.urls.apiBaseUrl}onboarding/app`
      : `${environment.urls.apiBaseUrl}onboarding/library`;
    return this.httpClient.post<any>(url, params, { withCredentials: true });
  }

  getHybridTechnology() {
    return this.httpClient.get<any>(
      environment.urls.apiBaseUrl + 'onboarding/get_hybrid_frameworks',
      { withCredentials: true },
    );
  }

  getAppTypes(): Observable<AppTypesApiResponse> {
    return this.httpClient.get<AppTypesApiResponse>(
      environment.urls.apiBaseUrl + 'apps/types',
      { withCredentials: true },
    );
  }

  getUserAndNavigate(
    navigation: Navigation,
    router: Router,
    isForm: boolean = false,
  ): User | null {
    const userFromState = navigation?.extras?.state?.['user'];
    const storedUser = sessionStorage.getItem('user');
    if (userFromState) {
      const user = userFromState as User;
      sessionStorage.setItem('user', JSON.stringify(user));
      return user;
    }
    const user = storedUser ? (JSON.parse(storedUser) as User) : null;
    if (!isForm) {
      if (sessionStorage.getItem('asset')) {
        sessionStorage.removeItem('asset');
      } else if (sessionStorage.getItem('back')) {
        sessionStorage.removeItem('back');
      } else {
        router.navigate([`/${SECTIONS_PAGE.DASHBOARD}`]);
      }
    }
    return user;
  }

  mapParamsToLibraryBody(params: any): OnBoardingLibraryDto {
    return {
      name: params.name,
      ios: params.is_ios,
      android: params.is_android,
      owner: params.app_owner,
    } as OnBoardingLibraryDto;
  }
}
